<script setup lang="ts">
</script>
<template>
  <div
    class="swiper-slide"
  >
    <div
      class="swiper-zoom-container"
    >
      <slot name="slide_content" />
    </div>
  </div>
</template>
